import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Paginator from "../../components/Paginator";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Dailyplayerreport = () => {
  const [dailyplayerreport, setDailyplayerreport] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`dailyplayerreport?page=${page}`);
      setDailyplayerreport(data.data);
      setLastPage(data.meta.last_page);
    })();
  }, [page]);
  const del = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      await axios.delete(`dailyplayerreport/${id}`);
      setDailyplayerreport(
        dailyplayerreport.filter(
          (dailyplayerreport) => dailyplayerreport.id !== id,
        ),
      );
    }
  };
  return (
    <Wrapper pageTitle={"Daily Player Report"}>
      <div className="w-full overflow-hidden rounded-lg shadow-xs">
        <div className="w-full overflow-x-auto">
          <table className="w-full whitespace-no-wrap">
            <thead>
              <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                <th className="px-4 py-3">#Ref </th>
                <th className="px-4 py-3">Name </th>
                <th className="px-4 py-3">Msisdn </th>
                <th className="px-4 py-3">Play Amount </th>
                <th className="px-4 py-3">Won Amount</th>
                <th className="px-4 py-3">Total Plays </th>
                <th className="px-4 py-3">Report Date </th>
                <th className="px-4 py-3">Action</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
              {dailyplayerreport.map((dailyplayerreport) => {
                return (
                  <tr
                    key={dailyplayerreport.id}
                    className="text-gray-700 dark:text-gray-400"
                  >
                    <td className="px-4 py-5">{dailyplayerreport.id}</td>
                    <td className="px-4 py-3 text-sm">
                      {dailyplayerreport.name}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {dailyplayerreport.msisdn}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {dailyplayerreport.amount}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {dailyplayerreport.wonAmount}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {dailyplayerreport.plays}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      {dailyplayerreport.reportDate}
                    </td>
                    <td className="flex px-4 py-3 text-sm"></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Paginator lastPage={lastPage} pageChanged={setPage} />
      </div>
    </Wrapper>
  );
};
export default Dailyplayerreport;
